module.exports = __webpack_public_path__ + "img/制御工学5_5_1.b1a1baed.png";